<template>
  <div class="layout layout--default">
    <Nav v-if="hasNav" />
    <div class="site-content" :class="{ 'site-content--application': hasNav }">
      <Messages :context="$CONTEXTS.root" />
      <slot></slot>
    </div>
    <Footer v-if="hasFooter" :isVisible="isFooterVisible" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Messages from '@/components/_shared/Messages/Messages.vue'
import Nav from '@/components/Navigation/Navigation.vue'
import Footer from '@/components/Footer/Footer.vue'

export default {
  name: 'DefaultLayout',

  components: {
    Nav,
    Messages,
    Footer,
  },

  computed: {
    ...mapState('page', ['isFooterVisible', 'hasNav', 'hasFooter']),
  },
}
</script>
